module.exports = __webpack_public_path__ + "static/media/calefont8.de46cfc2.png";